import templateUrl from './inputSkeletonPlaceholder.html';

export default { templateUrl };
